module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/list-container/list-container.style.scss
// module id = 859
// module chunks = 2